function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.201 6.657H0v10.447c0 1.086.884 1.97 1.97 1.97h12.213a1.991 1.991 0 0 0 1.989-1.99V8.627c0-1.087-.884-1.97-1.97-1.97zM2.83 13.945h1.833a.586.586 0 1 1 0 1.172H2.829a.586.586 0 0 1 0-1.172zm3.665 2.923H2.83a.586.586 0 0 1 0-1.172h3.665a.586.586 0 1 1 0 1.172zM6.669 4.162a1.977 1.977 0 0 0-1.69-.94h-2.99A1.99 1.99 0 0 0 0 5.21v.275h7.528l-.86-1.323zM7.606 3.068l.035.052h3.823l-.967-1.536a1.977 1.977 0 0 0-1.69-.94h-2.99c-.923 0-1.7.632-1.924 1.485h2.023c.693 0 1.325.351 1.69.94z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.017 4.391H8.504l.743 1.094h5.115a2.981 2.981 0 0 1 2.982 2.981v8.33c0 .007.005.012.012.012h.655A1.991 1.991 0 0 0 20 14.818V6.374a1.983 1.983 0 0 0-1.983-1.983z"
}));

var SvgFolder = function SvgFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder.7d67b033.svg";
export { ForwardRef as ReactComponent };